export function getNotificationPlainText(content?: string | null): string {
  if (!content) {
    return '';
  }
  const normalized = content
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/p>/gi, ' ')
    .replace(/<\/li>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\s+/g, ' ')
    .trim();
  return normalized;
}

export function hasNotificationContent(content?: string | null): boolean {
  return getNotificationPlainText(content).length > 0;
}

export function truncateNotificationPreview(content?: string | null, maxLength = 120): string {
  const plainText = getNotificationPlainText(content);
  if (!plainText) {
    return '';
  }
  if (plainText.length <= maxLength) {
    return plainText;
  }
  return `${plainText.slice(0, maxLength).trim()}...`;
}
